import { AppManager, Input } from 'core/index';

import { raiseUserError } from 'apps/utils';
import { clientStore } from 'apps/client/app';
import { modalStore } from 'apps/modals/app';
import { LabelApp } from 'apps/issueTracker/apps/labelApp';
import { LabelMutation } from 'apps/issueTracker/gql';

export class LabelFormAppManager extends AppManager {
  static registryName = 'LabelFormAppManager';
  constructor(parent, init = {}) {
    super(parent, init);
    this.labelFormApp = new LabelApp(this, {});
    this.labelFormApp.newLabel();
    this.issueTracker = init.issueTracker;
    this.labelInput = new Input({
      projectId: () => this.issueTracker.id,
      name: () => this.labelFormApp.name,
      color: () => this.labelFormApp.color.slice(1),
      restricted: () => this.labelFormApp.restricted,
    });
  }

  onSubmitError = error => {
    this.labelFormApp?.newLabelForm.SetPosting(false);
    clientStore.SetPosting(false);
    raiseUserError(error, 'create', 'Label');
  };

  onSubmitSuccess = () => {
    this.labelFormApp?.newLabelForm.SetPosting(false);
    this.labelFormApp?.newLabelForm.clearDraft();
    clientStore.SetPosting(false);
    modalStore.ClearComponent();
    this.labelFormApp?.ResetLocals();
  };

  Submit = () => {
    const { labelFormApp } = this;
    if (!labelFormApp) return;
    if (labelFormApp.newLabelForm.isValid) {
      labelFormApp.newLabelForm.SetPosting(true);
      clientStore.SetPosting(true);
      this.mutations.push(
        LabelMutation.New(this.labelInput, {
          onSysErr: this.onSubmitError,
          onUserErr: this.onSubmitError,
          onSuccess: this.onSubmitSuccess,
        }),
      );
    } else {
      this.newLabelForm.alert();
    }
  };
}
